import { industryLabel } from "../../data/results";
import { cx } from "../../lib/cx";
import { localHref, photoProps } from "../../lib/links";
import {
  BuildBadge,
  CaseQuote,
  Checklist,
  Modules,
  StatBand,
  TradeTag,
} from "./CaseParts";

function Column({ title, color, children, className }) {
  return (
    <div className={cx("px-6 py-6 md:px-8 md:py-7", className)}>
      <h3
        className={cx(
          "mb-3.5 text-sm font-bold tracking-[0.14em] uppercase",
          color,
        )}
      >
        {title}
      </h3>
      {children}
    </div>
  );
}

/**
 * Results page card: who they are, the headache, what we built, what's
 * running now, the numbers and the customer's own words.
 */
export default function CaseCard({ path, study }) {
  const { company, who, build, headaches, modules, runningNow } = study;
  return (
    <article className="overflow-hidden rounded-brand border border-line bg-white shadow-soft">
      <header className="flex flex-wrap items-center gap-x-6 gap-y-5 border-b border-line px-6 py-6 md:px-8">
        <img
          {...photoProps(study.photo, "152px")}
          alt=""
          loading="lazy"
          className="hidden aspect-[4/3] w-38 shrink-0 rounded-lg object-cover sm:block"
        />
        <div className="min-w-0 flex-[1_1_320px]">
          <TradeTag className="mb-2">{industryLabel(study)}</TradeTag>
          <h2 className="font-display text-[26px] text-ink uppercase md:text-[30px]">
            {company}
          </h2>
          <p className="mt-1 text-[15px] leading-snug text-muted">{who}</p>
        </div>
        <BuildBadge className="max-sm:w-full">{build}</BuildBadge>
      </header>

      <div className="grid grid-cols-1 divide-line max-lg:divide-y lg:grid-cols-3 lg:divide-x">
        <Column title="The headache" color="text-[#B0533B]">
          <Checklist items={headaches} kind="pain" />
        </Column>
        <Column title="What we built" color="text-blue-deep">
          <Modules items={modules} />
        </Column>
        <Column title="Running now" color="text-[#4E7A3A]">
          <Checklist items={runningNow} kind="now" />
        </Column>
      </div>

      {study.stats.length > 0 && <StatBand stats={study.stats} />}

      <footer
        className={cx(
          "flex flex-wrap items-center gap-x-10 gap-y-6 bg-surface px-6 py-6 md:px-8 md:py-7",
          !study.quote && "justify-end border-t border-line",
        )}
      >
        {study.quote && (
          <CaseQuote quote={study.quote} className="flex-[1_1_420px]" />
        )}
        <a
          href={localHref(path)}
          className="border-b-2 border-yellow pb-0.5 text-[15.5px] font-bold whitespace-nowrap text-blue-deep transition-colors hover:text-ink"
        >
          Read the full story
          <span className="sr-only"> of {company}</span> →
        </a>
      </footer>
    </article>
  );
}
